// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__vSBSw","fullScreen":"Loader_fullScreen__xixEr","loaderIcon":"Loader_loaderIcon__DdPMW"};